import React from 'react'
import { Redirect } from 'react-router-dom'
import { useAuth } from '@peracto/peracto-auth'

const RoleGuard = ({ roles, children }) => {
    const { user } = useAuth()
    const userRoles = user?.profile?.roles || []

    if (!roles.some((role) => userRoles.includes(role))) {
        return <Redirect to="/" />
    }

    return children
}

export const withRoleGuard = (Component, roles) => (props) => (
    <RoleGuard roles={roles}>
        <Component {...props} />
    </RoleGuard>
)

export default RoleGuard